import React, { Component } from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../context/CustomContext';
import notificationService from '../../../services/NotificationService';

class EventsMediaPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: false });
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return <div>Events Media Capture</div>;
    };

    render() {
        return <LayoutComponent page="events-media" content={this.renderContent} />;
    }
}
export default injectIntl(EventsMediaPage);

interface Props extends WrappedComponentProps {}

interface State {
    loading?: boolean;
}
